import { questions, maxScore } from '@/data/questions'
import { getTier } from '@/lib/scoring'

export interface PreviewData {
  totalScore: number
  percent: number
  tier: ReturnType<typeof getTier>
  answeredCount: number
  isComplete: boolean
}

export function getPreview(answers: Record<string, number>): PreviewData {
  const totalScore = Object.values(answers).reduce((sum, v) => sum + v, 0)
  const answeredCount = Object.keys(answers).length
  const isComplete = answeredCount >= questions.length
  const percent = Math.round((totalScore / maxScore) * 100)
  const tier = getTier(totalScore)
  return { totalScore, percent, tier, answeredCount, isComplete }
}
